import _ from 'underscore';

const serializecsvRow = (imageUrl, aid) => `Image,Active,GenericImage,,,${aid},${imageUrl}`;

export const serializeCSV = (imageUrls, aid) => {
  if (_.isEmpty(imageUrls)) {
    return [];
  }

  const csvHeader = 'Type,Status,Sub Type,Id, Name,Parent Id,Url';
  const csvFormat = 'Format Version,,,,6,,';
  const csvRows = _.map(imageUrls, imageUrl => serializecsvRow(imageUrl, aid));
  const csv = _.flatten([csvHeader, csvFormat, csvRows]);

  return csv;
};


export const parse = (csvData) => {
  const results = [];
  const errors = [];

  const headers = csvData[0];

  // first line is header, second line is format version. needs to be skipped.
  const data = csvData.slice(2);

  let errorColIndex = -1;
  let imageIdColIndex = -1;
  let uploadUrlColIndex = -1;

  _.each(headers, (col, index) => {
    if (col === 'Id') {
      imageIdColIndex = index;
    } else if (col === 'Error') {
      errorColIndex = index;
    } else if (col === 'Url') {
      uploadUrlColIndex = index;
    }
  });

  _.each(data, (row) => {
    if (errorColIndex !== -1 && row[errorColIndex]) {
      errors.push(row[errorColIndex]);
    } else {
      // Will push undefined imageId if that image is not uploaded correctly
      // the upload url will always defined
      results.push({
        imageId: row[imageIdColIndex],
        uploadUrl: row[uploadUrlColIndex],
      });
    }
  });

  return {
    results,
    errors,
  };
};
